import React from 'react';
import {
  AccordionsItem,
  AccordionsItemHeader,
  AccordionsItemSection,
  Gutter,
  Paragraph,
  ParagraphHeader,
  ReadonlyTextarea,
  SmallHeader,
} from '@axiom/ui';
import type { UseOnboardingTextReturn } from '@axiom/ui';

import type { Nullable } from '../../types/utility.types';

export type OnboardingLegalProps = {
  name?: string;
  texts: Nullable<
    Pick<
      NonNullable<ReturnType<UseOnboardingTextReturn['getOnboardingTexts']>>,
      | 'describingAxiom'
      | 'supportResources'
      | 'communications'
      | 'workLocationWorkingRemotely'
    >
  >;
};

export const EngagementDetailsLegal = ({
  name,
  texts,
}: OnboardingLegalProps) => {
  return (
    <AccordionsItem name={name}>
      <AccordionsItemHeader>
        <SmallHeader>Legal</SmallHeader>
      </AccordionsItemHeader>
      <AccordionsItemSection>
        <Gutter top="24px" />
        {texts.describingAxiom ? (
          <>
            <ParagraphHeader>Describing Axiom:</ParagraphHeader>
            <Gutter bottom="8px" />
            <Paragraph>
              <ReadonlyTextarea
                name="DESCRIBING_AXIOM"
                value={texts.describingAxiom}
                formatting="modern"
              />
            </Paragraph>
            <Gutter bottom="24px" />
          </>
        ) : null}
        {texts.supportResources ? (
          <>
            <ParagraphHeader>Support and Resources:</ParagraphHeader>
            <Gutter bottom="8px" />
            <Paragraph>
              <ReadonlyTextarea
                name="SUPPORT_AND_RESOURCES"
                value={texts.supportResources}
                formatting="modern"
              />
            </Paragraph>
          </>
        ) : null}
        <Gutter bottom={texts.communications ? '8px' : '0px'} />
        {texts.communications ? (
          <Paragraph>
            <ReadonlyTextarea
              name="COMMUNICATIONS"
              value={texts.communications}
              formatting="modern"
            />
          </Paragraph>
        ) : null}
        {texts.workLocationWorkingRemotely ? (
          <Gutter top="24px">
            <ParagraphHeader>Work Location & Working Remotely:</ParagraphHeader>
            <Gutter bottom="8px" />
            <Paragraph>
              <ReadonlyTextarea
                name="WORK_LOCATION_WORKING_REMOTELY"
                value={texts.workLocationWorkingRemotely}
                formatting="modern"
              />
            </Paragraph>
          </Gutter>
        ) : null}
      </AccordionsItemSection>
    </AccordionsItem>
  );
};
